<template>
  <div>
    <v-data-table
      dense
      :headers="headers"
      :items="branchRequestedList"
      item-key="name"
      class="elevation-1"
      >
      <template v-slot:item.studentName="{item}">
        <span class="text-capitalize">
          {{ item?.oldStudentEnrollment?.studentName || '-' }}
        </span>
      </template>

      <template v-slot:item.newEnrollmentID="{item}">
        {{ item?.newStudentEnrollment?.enrollmentCode || '-' }}
      </template>

      <template v-slot:item.isKitReceived="{item}">
        {{ item.isKitReceived ? 'Yes' : 'No' }}
      </template>

      <template v-slot:item.branchTransferStatus="{ item }">
        <v-btn
          small
          color="darkblue"
          class="white--text px-2 ml-0 ma-1"
          style="pointer-events: none; cursor: default;"
          >
          {{ item.branchTransferStatus?.position }} - {{ item.branchTransferStatus?.status  }}
        </v-btn>
      </template>

      <template v-slot:item.action="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="darkblue"
              class="white--text px-2 ml-0 ma-1"
              min-width="0"
              small
              v-bind="attrs"
              v-on="on"
              :to="{ name: 'branchDashboard', params: { branchTransferID: item.id } }"
            >
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
          <span>View</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="info"
              class="px-2 ml-1 ma-1"
              min-width="0"
              small
              v-bind="attrs"
              v-on="on"
              @click="openLogDialogue(item)"
            >
              <v-icon small>mdi-file-document</v-icon>
            </v-btn>
          </template>
          <span>Approval Logs</span>
        </v-tooltip>

        <v-tooltip bottom v-if="isReapplyAvailable(item)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              min-width="0"
              class="light-green darken-4 white--text px-2 ma-1"
              small
              v-bind="attrs"
              v-on="on"
              :to="{ name: 'initiateBranchTransfer', params: { enrollmentCode: item.oldStudentEnrollment.enrollmentCode } }"
            >
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </template>
          <span>Reapply</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="700px" @input="onDialogToggle">
      <v-card>
        <v-card-title>
          Branch transfer Logs
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 40vh; overflow-y: auto;">
          <v-data-table
            :headers="logHeaders"
            :items="logData"
            dense
            class="elevation-1"
            hide-default-footer
            disable-sort
            >
            <template v-slot:item.position="{ item }">
              <span class="text-capitalize">
                {{ item.branchTransferStatus?.position || '-' }}
              </span>
            </template>

            <template v-slot:item.status="{ item }">
              <span class="text-capitalize">
                {{ item.branchTransferStatus?.status || '-' }}
              </span>
            </template>
            <template v-slot:item.createdAt="{ item }">
              {{ formatDate(item.createdAt) }}
            </template>
            <template v-slot:item.remark="{ item }">
              {{ item.remark || '-' }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

import moment from 'moment'
import constants from '@/utils/constants'
import Utils from '@/utils'

export default {
  name: 'BranchTransferTableComponent',
  props: ['branchListArray', 'isSuperAdmin'],
  data () {
    return {
      dialog: false,
      headers: [
        { text: 'Student Name', width: '170px', align: 'left', value: 'studentName' },
        { text: 'From Franchisee', width: '170px', align: 'left', value: 'oldFranchisee.companyName' },
        { text: 'To Franchisee', width: '150px', align: 'left', value: 'newFranchisee.companyName' },
        { text: 'Old Enrollment Code', width: '200px', align: 'left', value: 'oldStudentEnrollment.enrollmentCode' },
        { text: 'New Enrollment Code', width: '200px', align: 'left', value: 'newEnrollmentID' },
        { text: 'Academic Year', width: '150px', align: 'left', value: 'franchiseeAcademicYear.academicYear' },
        { text: 'Class', width: '150px', align: 'left', value: 'studentClass.name' },
        { text: 'Exit Date', width: '150px', align: 'left', value: 'lastDateOfOldFranchisee' },
        { text: 'New Joining Date', width: '150px', align: 'left', value: 'joiningDateOfnewFranchisee' },
        { text: 'Kit Received', width: '150px', align: 'left', value: 'isKitReceived' },
        { text: 'Created At', width: '150px', align: 'left', value: 'createdAt' },
        { text: 'Updated By', width: '300px', align: 'left', value: 'updatedBy' },
        { text: 'Status', width: '300px', align: 'left', value: 'branchTransferStatus' },
        { text: 'Action', width: '150px', align: 'left', value: 'action' }
      ],
      branchRequestedList: [],
      logHeaders: [
        { text: 'Postion', align: 'left', width: '150px', value: 'position' },
        { text: 'Status', align: 'left', width: '200px', value: 'status' },
        { text: 'Remarks', align: 'left', width: '250px', value: 'remark' },
        { text: 'Created By', align: 'left', width: '300px', value: 'createdBy' },
        { text: 'Created At', align: 'left', width: '200px', value: 'createdAt' }
      ],
      selectedItem: null,
      logData: [],
      position: { ...constants.BRANCH_TRANSFER.roles },
      status: { ...constants.BRANCH_TRANSFER.status }
    }
  },
  watch: {
    branchListArray: {
      handler: function (newVal) {
        newVal.forEach(item => {
          item.lastDateOfOldFranchisee = moment(item.lastDateOfOldFranchisee).format('YYYY-MM-DD')
          item.joiningDateOfnewFranchisee = moment(item.joiningDateOfnewFranchisee).format('YYYY-MM-DD')
          item.createdAt = moment(item.createdAt).format('YYYY-MM-DD')
        })
        this.branchRequestedList = newVal
      },
      deep: true
    }
  },
  created () {

  },
  methods: {
    isReapplyAvailable (item) {
      if (item.isZOM || this.isSuperAdmin) {
        if (item.branchTransferStatus?.status === this.status.rejected ||
          item.branchTransferStatus?.status === this.status.revoked
        ) {
          return true
        }
      }
      return false
    },
    formatDate (val) {
      return Utils.helper.formatDate(val, true)
    },
    onDialogToggle (val) {
      if (!val) {
        this.logData = []
      }
    },
    openLogDialogue (item) {
      if (item.id) {
        this.dialog = true
        this.fetchLogData(item.id)
      }
    },
    async fetchLogData (id) {
      try {
        let { data } = await http.get(`${constants.API_URL}/api/v1/branch-transfer/${id}/logs`)
        this.logData = data
      } catch (error) {
        this.logData = []
      }
    }
  }
}
</script>
